import "./tabs.scss";

window.app.directive("msTabs", [
  function() {
    return {
      restrict: "E",
      scope: {
        tabs: "="
      },
      template: require("./tabs.html")
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/tabs/tabs.js